import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import { LoadingPanel } from "../../LoadingPanel";
import { AdministratorTicketingWebsiteAlertVenues } from "./TicketingWebsiteAlertVenues";
import { AdministratorTicketingWebsiteAlertLogs } from "./TicketingWebsiteAlertLogs";

import {
    FormInput,
    FormCheckbox,
    FormDropDownList
} from "../../forms/form-components";

import './TicketingWebsiteAlert.scss';

export const AdministratorTicketingWebsiteAlert = (props) => {
    const dispatch = useDispatch();

    const [selectedTab, setSelectedTab] = useState(0);

    const handleSubmit = (dataItem) => {    
        let fetchMethod, successMessage;

        if (!dataItem.ticketingWebsiteAlertKey) {
            //Create new ticketingWebsiteAlert
            fetchMethod = "POST";
            successMessage = "Created item successfully";
        }
        else {
            //Update existing ticketingWebsiteAlert
            fetchMethod = "PUT";
            successMessage = "Updated item successfully";
        }

        dataItem.ticketingWebsiteId = dataItem.ticketingWebsite.ticketingWebsiteId;
        dataItem.ticketStockTypeId = dataItem.ticketStockType.ticketStockTypeId;
        dataItem.ticketDeliveryMethodId = dataItem.ticketDeliveryMethod.ticketDeliveryMethodId;

        if (dataItem.ticketStockTypeId === "") {
            dataItem.ticketStockTypeId = null;
        }

        if (dataItem.ticketDeliveryMethodId === "") {
            dataItem.ticketDeliveryMethodId = null;
        }

        fetch("/api/administrator/ticketingwebsitealert",
            {
                method: fetchMethod,
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                addNotificationWithTimeout(dispatch, "success", successMessage);

                props.selectTicketingWebsiteAlert(result.ticketingWebsiteAlertKey);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const deleteTicketingWebsiteAlert = (ticketingWebsiteAlertKey) => {
        if (window.confirm("Are you sure you want to delete this item?") === false) {
            return;
        }

        const dataItem = {
            ticketingWebsiteAlertKey: ticketingWebsiteAlertKey
        }

        fetch("/api/administrator/ticketingwebsitealert",
            {
                method: "DELETE",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                addNotificationWithTimeout(dispatch, "success", "Deleted item successfully");

                props.cancel();
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const deleteFutureEvents = (ticketingWebsiteAlertKey) => {
        if (window.confirm("Are you sure you want to delete the future events for this alert?") === false) {
            return;
        }

        const dataItem = {
            ticketingWebsiteAlertKey: ticketingWebsiteAlertKey
        }

        fetch("/api/administrator/ticketingwebsitealertdeletefuturevenueevents",
            {
                method: "DELETE",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                addNotificationWithTimeout(dispatch, "success", "Deleted future events for this alert");
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const forceRunAlert = (ticketingWebsiteAlertKey) => {        
        const dataItem = {
            ticketingWebsiteAlertKey: ticketingWebsiteAlertKey,
        }

        fetch(`/api/administrator/ticketingwebsitealertforcedrun`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                addNotificationWithTimeout(dispatch, "success", "Alert will be forced to run");
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const fiftyCharacterRequiredValidator = (value) => {
        if (!value) {
            return "This field is required";
        }

        if (value.length > 50) {
            return "Maximum length is 50 characters";
        }

        return "";
    }

    const oneThousandCharacterValidator = (value) => {
        if (!value) {
            return "";
        }

        if (value.length > 1000) {
            return "Maximum length is 1,000 characters";
        }

        return "";
    }

    const oneThousandCharacterRequiredValidator = (value) => {
        if (!value) {
            return "This field is required";
        }

        if (value.length > 1000) {
            return "Maximum length is 1,000 characters";
        }

        return "";
    }

    const requiredValidator = (value) => {
        if (!value) {
            return "This field is required";
        }

        return "";
    }

    const tabStripSelectionChanged = (e) => {
        setSelectedTab(e.selected);
    };

    const getForm = (ticketingWebsiteAlert) => {
        if (!ticketingWebsiteAlert) {
            ticketingWebsiteAlert = {
                isActive: true,
                includeNewEventsInEmail: true,
                includeChangedEventsInEmail: true,
                includeRemovedEventsInEmail: true,
                onlyIncludeEventsWithCountsInEmail: false,
                ticketStockTypeId: null,
                ticketDeliveryMethodId: null,
                ticketStockType: props.ticketStockTypes.find(element => element.ticketStockTypeId === ""),
                ticketDeliveryMethod: props.ticketDeliveryMethods.find(element => element.ticketDeliveryMethodId === ""),
            }
        }
        else {
            ticketingWebsiteAlert.ticketingWebsite = props.ticketingWebsites.find(element => element.ticketingWebsiteId === ticketingWebsiteAlert.ticketingWebsiteId);

            const ticketStockTypeIdToFind = ticketingWebsiteAlert.ticketStockTypeId ?? "";
            ticketingWebsiteAlert.ticketStockType = props.ticketStockTypes.find(element => element.ticketStockTypeId === ticketStockTypeIdToFind);

            const ticketDeliveryMethodIdToFind = ticketingWebsiteAlert.ticketDeliveryMethodId ?? "";
            ticketingWebsiteAlert.ticketDeliveryMethod = props.ticketDeliveryMethods.find(element => element.ticketDeliveryMethodId === ticketDeliveryMethodIdToFind);
        }

        if (!ticketingWebsiteAlert?.ticketingWebsiteAlertKey && selectedTab > 0) {
            //Cannot have selected tab be a disabled one
            setSelectedTab(0);
        }
        
        return (
            <div className="administratorTicketingWebsiteAlert">
                <TabStrip selected={selectedTab} onSelect={tabStripSelectionChanged}>
                    <TabStripTab title={"Alert"}>
                        <Form
                            onSubmit={handleSubmit}
                            initialValues={ticketingWebsiteAlert}
                            key={JSON.stringify(ticketingWebsiteAlert)}
                            render={(formRenderProps) => (
                                <FormElement>
                                    <h2>
                                        {!ticketingWebsiteAlert?.ticketingWebsiteAlertKey ? "New Alert" : "Update Alert"}
                                    </h2>
                                    <fieldset className={"k-form-fieldset"}>
                                        {!ticketingWebsiteAlert?.ticketingWebsiteAlertKey ? "" :
                                            (<div className="mb-3 noFormField">
                                                <Label>Key:</Label> {ticketingWebsiteAlert.ticketingWebsiteAlertKey}
                                            </div>)
                                        }

                                        {!ticketingWebsiteAlert?.ticketingWebsiteAlertKey ? "" :
                                            (<div className="mb-3 noFormField">
                                                <Label>Created:</Label> {ticketingWebsiteAlert.dateCreated}
                                            </div>)
                                        }

                                        <div className="row">
                                            <div className="col-xl-4">
                                                <Field
                                                    id={"isActive"}
                                                    name={"isActive"}
                                                    label={"Active"}
                                                    component={FormCheckbox}
                                                />
                                            </div>
                                            <div className="col-xl-8">
                                                <Field
                                                    id={"onlyIncludeEventsWithCountsInEmail"}
                                                    name={"onlyIncludeEventsWithCountsInEmail"}
                                                    label={"ONLY include events with COUNTS in email"}
                                                    component={FormCheckbox}
                                                />
                                            </div>
                                        </div>
                                        
                                        <div className="row">
                                            <div className="col-xl-4">
                                                <Field
                                                    id={"includeNewEventsInEmail"}
                                                    name={"includeNewEventsInEmail"}
                                                    label={"Include NEW events in email"}
                                                    component={FormCheckbox}
                                                />
                                            </div>
                                            <div className="col-xl-4">
                                                <Field
                                                    id={"includeChangedEventsInEmail"}
                                                    name={"includeChangedEventsInEmail"}
                                                    label={"Include CHANGED events in email"}
                                                    component={FormCheckbox}
                                                />
                                            </div>
                                            <div className="col-xl-4">
                                                <Field
                                                    id={"includeRemovedEventsInEmail"}
                                                    name={"includeRemovedEventsInEmail"}
                                                    label={"Include REMOVED events in email"}
                                                    component={FormCheckbox}
                                                />
                                            </div>
                                        </div>
                                        
                                        <Field
                                            id={"ticketingWebsite"}
                                            name={"ticketingWebsite"}
                                            label={"Ticketing website"}
                                            component={FormDropDownList}
                                            data={props.ticketingWebsites}
                                            textField="name"
                                            dataItemKey="ticketingWebsiteId"
                                            validator={requiredValidator}
                                        /> 
                            
                                        <Field
                                            id={"label"}
                                            name={"label"}
                                            label={"Label"}
                                            component={FormInput}
                                            validator={fiftyCharacterRequiredValidator}
                                        />

                                        <Field
                                            id={"parameter1"}
                                            name={"parameter1"}
                                            label={"Parameter 1"}
                                            component={FormInput}
                                            validator={oneThousandCharacterRequiredValidator}
                                        />

                                        <Field
                                            id={"parameter2"}
                                            name={"parameter2"}
                                            label={"Parameter 2"}
                                            component={FormInput}
                                            validator={oneThousandCharacterValidator}
                                        />

                                        <Field
                                            id={"ticketStockType"}
                                            name={"ticketStockType"}
                                            label={"Ticket stock type"}
                                            component={FormDropDownList}
                                            data={props.ticketStockTypes}
                                            textField="name"
                                            dataItemKey="ticketStockTypeId"
                                            validator={requiredValidator}
                                        /> 

                                        <Field
                                            id={"ticketDeliveryMethod"}
                                            name={"ticketDeliveryMethod"}
                                            label={"Ticket delivery method"}
                                            component={FormDropDownList}
                                            data={props.ticketDeliveryMethods}
                                            textField="name"
                                            dataItemKey="ticketDeliveryMethodId"
                                            validator={requiredValidator}
                                        /> 
                                    </fieldset>
                                    <span className={"k-form-separator"} />
                                    <div className="k-form-buttons">
                                        <Button
                                            themeColor={"primary"}
                                            type={"submit"}
                                            disabled={!formRenderProps.allowSubmit}
                                            >
                                            Save
                                        </Button>

                                        {!ticketingWebsiteAlert?.ticketingWebsiteAlertKey ? null :
                                            <>
                                                <Button
                                                    type={"button"}
                                                    className={"deleteButton"}
                                                    onClick={() => deleteTicketingWebsiteAlert(ticketingWebsiteAlert.ticketingWebsiteAlertKey)}>
                                                    Delete
                                                </Button>
                                                
                                                {ticketingWebsiteAlert.isActive === false ?
                                                    <Button
                                                        type={"button"}
                                                        className={"deleteButton"}
                                                        onClick={() => deleteFutureEvents(ticketingWebsiteAlert.ticketingWebsiteAlertKey)}>
                                                        Delete Future Events
                                                    </Button>
                                                    : 
                                                    <Button
                                                        type={"button"}   
                                                        className={"deleteButton"}
                                                        onClick={() => forceRunAlert(ticketingWebsiteAlert.ticketingWebsiteAlertKey)}>
                                                        Force Run
                                                    </Button>
                                                }
                                            </>
                                        }
                                    </div>
                                </FormElement>
                            )}
                        />
                    </TabStripTab>
                    <TabStripTab title={"Venues"} disabled={!ticketingWebsiteAlert?.ticketingWebsiteAlertKey}>
                        <AdministratorTicketingWebsiteAlertVenues ticketingWebsiteAlertKey={ticketingWebsiteAlert?.ticketingWebsiteAlertKey} />
                    </TabStripTab>
                    <TabStripTab title={"Logs"} disabled={!ticketingWebsiteAlert?.ticketingWebsiteAlertKey}>
                        <AdministratorTicketingWebsiteAlertLogs ticketingWebsiteAlertKey={ticketingWebsiteAlert?.ticketingWebsiteAlertKey} />
                    </TabStripTab>
                </TabStrip>
                <div className="administratorTicketingWebsiteAlertClose">
                    <Button
                        themeColor={"primary"}
                        type={"button"}
                        onClick={props.cancel}
                    >
                        Close
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <>
            { props.loading === true ? <LoadingPanel /> : (props.createNewTicketingWebsiteAlert === true ? getForm() : (props.ticketingWebsiteAlert ? getForm(props.ticketingWebsiteAlert) : <div></div>))}
        </>
    );
}